import React, { useEffect, useState } from 'react';
import '../styles/Preloader.css';

const Preloader = () => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setProgress(prev => {
        if (prev >= 100) {
          clearInterval(interval);
          return 100;
        }
        return prev + Math.random() * 15;
      });
    }, 100);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="preloader">
      <div className="preloader-content">
        <div className="preloader-logo">
          <span className="preloader-logo-text">ISPCLUB</span>
        </div>
        <div className="preloader-bar-container">
          <div className="preloader-bar" style={{ width: `${Math.min(progress, 100)}%` }}></div>
        </div>
        <div className="preloader-status">
          <span className="preloader-label">Initializing system</span>
          <span className="preloader-percent">{Math.min(Math.floor(progress), 100)}%</span>
        </div>
        <div className="preloader-terminal">
          <span className="terminal-line">&gt; Loading modules...</span>
          {progress > 30 && <span className="terminal-line">&gt; Establishing secure connection...</span>}
          {progress > 60 && <span className="terminal-line">&gt; Decrypting assets...</span>}
          {progress > 90 && <span className="terminal-line success">&gt; System ready.</span>}
        </div>
      </div>
    </div>
  );
};

export default Preloader;
